<template>
  <generic-modal :modal-key="'spin_wheel_prize'" :has-extra-modal-class="'new_achievement_box modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_prize_yeah }}
          <br> {{ getTranslations.home_modals_notifications_spin_wheel_prize_you }}
          {{ getTranslations[prizeInfo.prizeName] }}</h1>
        <img src="static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="$emit('close')">
          {{ getTranslations.home_modals_notifications_spin_wheel_prize_continue }}
        </button>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

// achievements_modal_wheel_prize.html
export default {
  name: 'spin-wheel-prize',
  components: { GenericModal },
  props: {
    prizeInfo: Object,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/spinwheel/SpinWheelPrize.vue